export const PANEL_PARAMS = Object.freeze([
  'showreelBuilder',
  'transcription',
  'videoSources'
])
